export default __webpack_public_path__ + "static/031-9cefc7662ca41e438ac0aa74aae4ef53.jpg";